module.exports = __webpack_public_path__ + "static/img/12.5c17b56.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/12.png
// module id = IxTb
// module chunks = 0